import { convertToRaw, ContentState } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';

export interface ContagemDeCaracteres {
  textLength: number;
  fullLength: number;
}

const normalizarEspacos = (texto: string) =>
  texto
    .replace(/(\n|&nbsp;)/gi, ' ')
    .replace(/\s+/gi, ' ')
    .trim();

/** Contagem do `TextEditor`: `textLength` sem emojis do plugin, `fullLength` com cada um contando 1. */
export function contarCaracteres(plainText: string, rawContent: any): ContagemDeCaracteres {
  let texto = typeof plainText === 'string' ? normalizarEspacos(plainText) : '';
  let emojis = 0;

  if (texto.length <= 0) {
    return { textLength: 0, fullLength: 0 };
  }

  if (rawContent?.entityMap[0]?.type) {
    Object.keys(rawContent?.entityMap).forEach(key => {
      const entidade = rawContent?.entityMap[key];

      if (entidade?.type === 'emoji' && entidade?.data?.emojiUnicode) {
        emojis++;
        texto = texto.replace(entidade?.data?.emojiUnicode, '');
      }
    });
  }

  const tamanho = normalizarEspacos(texto).length;
  return { textLength: tamanho, fullLength: tamanho + emojis };
}

/** Contagem que o `TextEditor` mostra ao montar com `initialValue` = `html`. */
export function contarCaracteresDoHtml(html?: string): ContagemDeCaracteres {
  const conteudo = html ? stateFromHTML(html) : ContentState.createFromText('');
  return contarCaracteres(conteudo.getPlainText(), convertToRaw(conteudo));
}
